<div class="body">

    <ng-container *ngFor="let error of step.errors">

        <div class="error-wrapper">

            STATUS {{error.status}}: {{error.error}}

        </div>

    </ng-container>

</div>
